import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.string.trim.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.symbol.description.js";
import _regeneratorRuntime from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/createClass";
import _defineProperty from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

import { ErrorResponse } from "./errors";
import { formatAMPM, formatDate, formatPhoneNumber, getLocalISODateString } from "@dp/common";
import moment from "moment-timezone";

var Cart = /*#__PURE__*/function () {
  function Cart(config, axios) {
    _classCallCheck(this, Cart);

    _defineProperty(this, "axios", void 0);

    _defineProperty(this, "config", void 0);

    this.axios = axios;
    this.config = config;
  }

  _createClass(Cart, [{
    key: "updateItem",
    value: function () {
      var _updateItem = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(productId, catalogRefIds, quantity, itemInstructions, selectedIds, configQuantity) {
        var commerceIds,
            guestName,
            itemCourse,
            commonQueryParams,
            locale,
            response,
            successResp,
            _response$data,
            _args = arguments;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                commerceIds = _args.length > 6 && _args[6] !== undefined ? _args[6] : "";
                guestName = _args.length > 7 && _args[7] !== undefined ? _args[7] : null;
                itemCourse = _args.length > 8 ? _args[8] : undefined;
                commonQueryParams = this.config.getCommonQueryParams();
                locale = commonQueryParams && commonQueryParams.locale ? commonQueryParams.locale : "en_US";
                _context.next = 7;
                return this.axios.post(this.config.postfix.UPDATE_ITEM + "?".concat(commerceIds, "=").concat(quantity), {
                  productID: productId,
                  catalogRefIds: catalogRefIds ? catalogRefIds.join(",") : "",
                  selectedIds: selectedIds ? selectedIds.join(",") : "",
                  Quantity: quantity,
                  ConfigQuantity: configQuantity,
                  locale: locale,
                  itemInstructions: itemInstructions ? itemInstructions : undefined,
                  commerceIds: commerceIds,
                  guestName: guestName ? guestName : undefined,
                  itemCourse: itemCourse
                });

              case 7:
                response = _context.sent;
                successResp = response.data.successResponse;

                if (!successResp) {
                  _context.next = 13;
                  break;
                }

                return _context.abrupt("return", response.data.successResponse);

              case 13:
                throw response === null || response === void 0 ? void 0 : (_response$data = response.data) === null || _response$data === void 0 ? void 0 : _response$data.errorResponse;

              case 14:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function updateItem(_x, _x2, _x3, _x4, _x5, _x6) {
        return _updateItem.apply(this, arguments);
      }

      return updateItem;
    }()
  }, {
    key: "addItem",
    value: function () {
      var _addItem = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(restaurantId, productId, catalogRefIds, selectedIds, quantity, configQuantity, fromPage) {
        var _response$data2;

        var smartRecommended,
            itemInstructions,
            guestName,
            itemCourse,
            commonQueryParams,
            locale,
            response,
            successResp,
            _response$data3,
            _response$data4,
            _args2 = arguments;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                smartRecommended = _args2.length > 7 && _args2[7] !== undefined ? _args2[7] : false;
                itemInstructions = _args2.length > 8 && _args2[8] !== undefined ? _args2[8] : null;
                guestName = _args2.length > 9 && _args2[9] !== undefined ? _args2[9] : null;
                itemCourse = _args2.length > 10 ? _args2[10] : undefined;
                commonQueryParams = this.config.getCommonQueryParams();
                locale = commonQueryParams && commonQueryParams.locale ? commonQueryParams.locale : "en_US";
                _context2.next = 8;
                return this.axios.post(this.config.postfix.ADD_ITEM, {
                  restaurantId: restaurantId,
                  productID: productId,
                  catalogRefIds: catalogRefIds ? catalogRefIds.join(",") : "",
                  selectedIds: selectedIds ? selectedIds.join(",") : "",
                  Quantity: quantity,
                  fromPage: fromPage,
                  ConfigQuantity: 1,
                  locale: locale,
                  smartRecommended: smartRecommended,
                  itemInstructions: itemInstructions ? itemInstructions : undefined,
                  guestName: guestName ? guestName : undefined,
                  itemCourse: itemCourse
                });

              case 8:
                response = _context2.sent;
                successResp = response === null || response === void 0 ? void 0 : (_response$data2 = response.data) === null || _response$data2 === void 0 ? void 0 : _response$data2.successResponse;

                if (!successResp) {
                  _context2.next = 14;
                  break;
                }

                return _context2.abrupt("return", response === null || response === void 0 ? void 0 : (_response$data3 = response.data) === null || _response$data3 === void 0 ? void 0 : _response$data3.successResponse);

              case 14:
                throw response === null || response === void 0 ? void 0 : (_response$data4 = response.data) === null || _response$data4 === void 0 ? void 0 : _response$data4.errorResponse;

              case 15:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function addItem(_x7, _x8, _x9, _x10, _x11, _x12, _x13) {
        return _addItem.apply(this, arguments);
      }

      return addItem;
    }()
  }, {
    key: "deleteItem",
    value: function () {
      var _deleteItem = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(removalCommerceIds, skuId, productId) {
        var _response$data5;

        var commonQueryParams, locale, response, successResp, _response$data6, _response$data7, _response$data8, _response$data8$formE;

        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                commonQueryParams = this.config.getCommonQueryParams();
                locale = commonQueryParams && commonQueryParams.locale ? commonQueryParams.locale : "en_US";
                _context3.next = 4;
                return this.axios.post(this.config.postfix.DELETE_ITEM, {
                  removalCommerceIds: removalCommerceIds,
                  skuId: skuId,
                  productId: productId,
                  locale: locale
                });

              case 4:
                response = _context3.sent;
                successResp = response === null || response === void 0 ? void 0 : (_response$data5 = response.data) === null || _response$data5 === void 0 ? void 0 : _response$data5.successResponse;

                if (!successResp) {
                  _context3.next = 10;
                  break;
                }

                return _context3.abrupt("return", response === null || response === void 0 ? void 0 : (_response$data6 = response.data) === null || _response$data6 === void 0 ? void 0 : _response$data6.successResponse);

              case 10:
                throw (response === null || response === void 0 ? void 0 : (_response$data7 = response.data) === null || _response$data7 === void 0 ? void 0 : _response$data7.errorResponse) || (response === null || response === void 0 ? void 0 : (_response$data8 = response.data) === null || _response$data8 === void 0 ? void 0 : (_response$data8$formE = _response$data8.formExceptions) === null || _response$data8$formE === void 0 ? void 0 : _response$data8$formE[0]);

              case 11:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function deleteItem(_x14, _x15, _x16) {
        return _deleteItem.apply(this, arguments);
      }

      return deleteItem;
    }()
  }, {
    key: "moveToPurchaseFlow",
    value: function () {
      var _moveToPurchaseFlow = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        var _response$data9;

        var togoNewFlow,
            commonQueryParams,
            locale,
            response,
            successResp,
            _response$data10,
            _response$data11,
            _args4 = arguments;

        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                togoNewFlow = _args4.length > 0 && _args4[0] !== undefined ? _args4[0] : true;
                commonQueryParams = this.config.getCommonQueryParams();
                locale = commonQueryParams && commonQueryParams.locale ? commonQueryParams.locale : "en_US";
                _context4.next = 5;
                return this.axios.post(this.config.postfix.MOVE_TO_PURCHASE, {
                  togoNewFlow: togoNewFlow,
                  locale: locale
                });

              case 5:
                response = _context4.sent;
                successResp = response === null || response === void 0 ? void 0 : (_response$data9 = response.data) === null || _response$data9 === void 0 ? void 0 : _response$data9.successResponse;

                if (!successResp) {
                  _context4.next = 11;
                  break;
                }

                return _context4.abrupt("return", response === null || response === void 0 ? void 0 : (_response$data10 = response.data) === null || _response$data10 === void 0 ? void 0 : _response$data10.successResponse);

              case 11:
                throw response === null || response === void 0 ? void 0 : (_response$data11 = response.data) === null || _response$data11 === void 0 ? void 0 : _response$data11.errorResponse;

              case 12:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function moveToPurchaseFlow() {
        return _moveToPurchaseFlow.apply(this, arguments);
      }

      return moveToPurchaseFlow;
    }()
  }, {
    key: "getCartDetails",
    value: function () {
      var _getCartDetails = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
        var response;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.prev = 0;
                _context5.next = 3;
                return this.axios.get(this.config.postfix.CART_ORDER_DETAILS);

              case 3:
                response = _context5.sent;
                return _context5.abrupt("return", response.data);

              case 7:
                _context5.prev = 7;
                _context5.t0 = _context5["catch"](0);
                return _context5.abrupt("return", null);

              case 10:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this, [[0, 7]]);
      }));

      function getCartDetails() {
        return _getCartDetails.apply(this, arguments);
      }

      return getCartDetails;
    }()
  }, {
    key: "applyCouponCode",
    value: function () {
      var _applyCouponCode = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(couponCode) {
        var _response$data12;

        var suppressCouponErrors,
            isPostCheckout,
            commonQueryParams,
            locale,
            response,
            _args6 = arguments;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                suppressCouponErrors = _args6.length > 1 && _args6[1] !== undefined ? _args6[1] : false;
                isPostCheckout = _args6.length > 2 && _args6[2] !== undefined ? _args6[2] : true;
                commonQueryParams = this.config.getCommonQueryParams();
                locale = commonQueryParams && commonQueryParams.locale ? commonQueryParams.locale : "en_US";
                _context6.next = 6;
                return this.axios.post(this.config.postfix.APPLY_COUPON, {
                  suppressCouponErrors: suppressCouponErrors,
                  currentCouponCode: couponCode,
                  webapi: true,
                  postCheckout: isPostCheckout,
                  locale: locale
                });

              case 6:
                response = _context6.sent;
                return _context6.abrupt("return", response === null || response === void 0 ? void 0 : (_response$data12 = response.data) === null || _response$data12 === void 0 ? void 0 : _response$data12.successResponse);

              case 8:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function applyCouponCode(_x17) {
        return _applyCouponCode.apply(this, arguments);
      }

      return applyCouponCode;
    }()
  }, {
    key: "parseErrors",
    value: function parseErrors(errorObj) {
      var _errorObj$response;

      var errResp = (errorObj === null || errorObj === void 0 ? void 0 : errorObj.errorResponse) || (errorObj === null || errorObj === void 0 ? void 0 : (_errorObj$response = errorObj.response) === null || _errorObj$response === void 0 ? void 0 : _errorObj$response.data);
      var faults = errResp === null || errResp === void 0 ? void 0 : errResp.fault;
      var unAvailableItems = errResp === null || errResp === void 0 ? void 0 : errResp.unavailableItems;
      var reconcileItems = errResp === null || errResp === void 0 ? void 0 : errResp.reconcileItemId;
      var formException = errResp === null || errResp === void 0 ? void 0 : errResp.form;
      var errorDescriptionJson = errResp === null || errResp === void 0 ? void 0 : errResp.errorDescriptionJson;

      if (faults || unAvailableItems || formException || reconcileItems || errorDescriptionJson) {
        return {
          faults: faults ? Array.isArray(faults) ? faults : [faults] : null,
          unAvailableItems: unAvailableItems ? Array.isArray(unAvailableItems) ? unAvailableItems : [unAvailableItems] : null,
          formException: formException ? Array.isArray(formException) ? formException : [formException] : null,
          reconcileItems: reconcileItems ? Array.isArray(reconcileItems) ? reconcileItems : [reconcileItems] : null,
          errorDescriptionJson: errorDescriptionJson !== null && errorDescriptionJson !== void 0 ? errorDescriptionJson : null
        };
      } else {
        return null;
      }
    }
  }, {
    key: "getFaultCodes",
    value: function getFaultCodes(errorObj) {
      var _errorObj$response2;

      var errResp = (errorObj === null || errorObj === void 0 ? void 0 : errorObj.errorResponse) || (errorObj === null || errorObj === void 0 ? void 0 : (_errorObj$response2 = errorObj.response) === null || _errorObj$response2 === void 0 ? void 0 : _errorObj$response2.data);
      var faults = errResp === null || errResp === void 0 ? void 0 : errResp.fault;

      if (faults) {
        if (Array.isArray(faults)) {
          return faults.map(function (fault) {
            return fault.faultCode || fault.faultDescription;
          });
        } else {
          return [faults.faultCode || faults.faultDescription];
        }
      } else {
        return [];
      }
    }
  }, {
    key: "removeCouponCode",
    value: function () {
      var _removeCouponCode = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(couponCode) {
        var _response$data13;

        var isPostCheckout,
            commonQueryParams,
            locale,
            response,
            _args7 = arguments;
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                isPostCheckout = _args7.length > 1 && _args7[1] !== undefined ? _args7[1] : true;
                commonQueryParams = this.config.getCommonQueryParams();
                locale = commonQueryParams && commonQueryParams.locale ? commonQueryParams.locale : "en_US";
                _context7.next = 5;
                return this.axios.post(this.config.postfix.REMOVE_COUPON, {
                  currentCouponCode: couponCode,
                  postCheckout: isPostCheckout,
                  locale: locale
                });

              case 5:
                response = _context7.sent;
                return _context7.abrupt("return", response === null || response === void 0 ? void 0 : (_response$data13 = response.data) === null || _response$data13 === void 0 ? void 0 : _response$data13.successResponse);

              case 7:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function removeCouponCode(_x18) {
        return _removeCouponCode.apply(this, arguments);
      }

      return removeCouponCode;
    }()
  }, {
    key: "submitOrder",
    value: function () {
      var _submitOrder = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(orderId, submitOrderRequest) {
        var _this = this,
            _response$data14;

        var commonQueryParams, locale, carType, carColor, carService, requestedPickupDateTime, requestedPickupDate, requestedPickupTime, utensils, payments, dfpParams, silverwareIncluded, paymentAlreadyProcessed, isReOrderFlow, menuPeriodCheck, defaultQuantity, configQuantity, complaint, confirmLocation, response, successResp;
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                commonQueryParams = this.config.getCommonQueryParams();
                locale = commonQueryParams && commonQueryParams.locale ? commonQueryParams.locale : "en_US";
                carType = submitOrderRequest.carType ? submitOrderRequest.carType.trim() : submitOrderRequest.carType;
                carColor = submitOrderRequest.carColor ? submitOrderRequest.carColor.trim() : submitOrderRequest.carColor;
                carService = carType && carColor ? "true" : "false";
                requestedPickupDateTime = submitOrderRequest.requestedPickupDateTime;
                requestedPickupDate = formatDate(requestedPickupDateTime);
                requestedPickupTime = formatAMPM(requestedPickupDateTime);
                utensils = submitOrderRequest.utensils;
                payments = submitOrderRequest.payments;
                delete submitOrderRequest.requestedPickupDateTime;
                delete submitOrderRequest.utensils;
                delete submitOrderRequest.payments;
                delete submitOrderRequest.restaurantId;
                dfpParams = submitOrderRequest.bamsCorrelationId ? {
                  correlationId: submitOrderRequest.bamsCorrelationId,
                  customerLocalDate: getLocalISODateString(moment().toDate())
                } : {};
                delete submitOrderRequest.bamsCorrelationId;
                silverwareIncluded = utensils.silverwareIncluded === null || utensils.silverwareIncluded === undefined ? {} : {
                  silverwareIncluded: utensils.silverwareIncluded ? "yes" : "no"
                };
                paymentAlreadyProcessed = submitOrderRequest.paymentAlreadyProcessed ? "true" : "false";
                isReOrderFlow = submitOrderRequest.isReOrderFlow ? "true" : "false";
                menuPeriodCheck = submitOrderRequest.menuPeriodCheck ? "true" : "false";
                defaultQuantity = submitOrderRequest.defaultQuantity && submitOrderRequest.defaultQuantity + "";
                configQuantity = submitOrderRequest.configQuantity && submitOrderRequest.configQuantity + "";
                complaint = submitOrderRequest.complaint ? "yes" : "no";
                confirmLocation = submitOrderRequest.confirmLocation ? "true" : "false";
                _context8.next = 26;
                return this.axios.post(this.config.postfix.SUBMIT_ORDER, _objectSpread(_objectSpread({}, submitOrderRequest), {}, {
                  paymentAlreadyProcessed: paymentAlreadyProcessed,
                  isReOrderFlow: isReOrderFlow,
                  menuPeriodCheck: menuPeriodCheck,
                  defaultQuantity: defaultQuantity,
                  configQuantity: configQuantity,
                  complaint: complaint,
                  confirmLocation: confirmLocation,
                  carService: carService,
                  locale: locale,
                  confirmEmailId: submitOrderRequest.emailId,
                  requestedPickupDate: requestedPickupDate,
                  requestedPickupTime: requestedPickupTime,
                  legalDrinkingAgeConfirmation: submitOrderRequest.legalDrinkingAgeConfirmation === null || submitOrderRequest.legalDrinkingAgeConfirmation === undefined ? null : submitOrderRequest.legalDrinkingAgeConfirmation ? "yes" : "no",
                  phoneNumber: formatPhoneNumber(submitOrderRequest.phoneNumber),
                  utensilsBean: {
                    "atg-rest-class-type": "java.util.HashMap",
                    "atg-rest-values": _objectSpread(_objectSpread(_objectSpread({}, utensils), silverwareIncluded), {}, {
                      silverwareIncluded: utensils.silverwareQty ? "yes" : "no",
                      platesIncluded: utensils.plateQty ? "true" : "false",
                      bowlsIncluded: utensils.bowlsQty ? "true" : "false",
                      cupsIncluded: utensils.cupQty ? "true" : "false",
                      butterIncluded: utensils.butterIncluded ? "true" : "false",
                      iceIncluded: utensils.iceIncluded ? "true" : "false",
                      breadIncluded: utensils.breadIncluded ? "yes" : "no",
                      condimentsList: utensils.condimentsList,
                      heatingKitIncluded: utensils.heatingKitIncluded ? "true" : "false"
                    })
                  },
                  paymentCollection: {
                    // eslint-disable-next-line sonarjs/no-duplicate-string
                    "atg-rest-class-type": "java.util.ArrayList",
                    "atg-rest-class-descriptor": {
                      "atg-rest-values": {
                        "container-class": "java.util.ArrayList",
                        "element-class": "com.darden.integration.paymentservice.bean.TransactionalDetail"
                      }
                    },
                    "atg-rest-values": payments.map(function (payment) {
                      if (payment.inStorePayment) {
                        return _objectSpread(_objectSpread({}, payment), {}, {
                          inStorePayment: _objectSpread({
                            "atg-rest-class-type": "com.darden.commerce.order.purchase.InStorePaymentBean"
                          }, payment.inStorePayment)
                        });
                      }

                      if (payment.creditCard) {
                        var _payment$creditCard$b, _payment$creditCard$b2, _payment$creditCard$b3, _payment$creditCard$b4;

                        var defaultCard = payment.creditCard["default"];
                        delete payment.creditCard["default"];
                        var isVaulted = payment.creditCard.isVaulted;
                        delete payment.creditCard.isVaulted;
                        var saveCardToProfile = payment.creditCard.saveCardToProfile;
                        var saveCardParams = saveCardToProfile ? {
                          updateSavedCardMandate: payment.creditCard.updateSavedCardMandate,
                          acceptClientType: payment.creditCard.acceptClientType,
                          acceptConceptCode: _this.config.getConceptCode(),
                          saveCardToProfile: true
                        } : {};
                        delete payment.creditCard.saveCardToProfile;
                        var cardOnFileFlag = saveCardToProfile || isVaulted ? {
                          cardOnFile: true
                        } : {
                          cardOnFile: false
                        };
                        return _objectSpread(_objectSpread(_objectSpread({}, payment), cardOnFileFlag), {}, {
                          makePayment: isVaulted ? true : false,
                          validateBillingAddress: (_payment$creditCard$b = payment.creditCard.billingAddress) !== null && _payment$creditCard$b !== void 0 && _payment$creditCard$b.address1 && (_payment$creditCard$b2 = payment.creditCard.billingAddress) !== null && _payment$creditCard$b2 !== void 0 && _payment$creditCard$b2.postalCode && (_payment$creditCard$b3 = payment.creditCard.billingAddress) !== null && _payment$creditCard$b3 !== void 0 && _payment$creditCard$b3.firstName && (_payment$creditCard$b4 = payment.creditCard.billingAddress) !== null && _payment$creditCard$b4 !== void 0 && _payment$creditCard$b4.lastName ? true : false,
                          transType: "TOG",
                          "default": defaultCard,
                          creditCard: _objectSpread(_objectSpread(_objectSpread(_objectSpread({
                            "atg-rest-class-type": "com.darden.commerce.order.purchase.CreditCardBean"
                          }, payment.creditCard), {}, {
                            billingAddress: _objectSpread({
                              "atg-rest-class-type": "atg.core.util.Address"
                            }, payment.creditCard.billingAddress)
                          }, payment.creditCard.paymentCVV ? {
                            paymentCVVEnabled: true
                          } : {}), dfpParams), saveCardParams),
                          authTransID: "",
                          status: "SUCCESS"
                        });
                      }

                      if (payment.giftCard) {
                        var gcNumber = payment.giftCard.giftCardNumber;

                        if (gcNumber) {
                          payment.giftCard.giftCardNumber = gcNumber.split("-").join("");
                        }

                        return _objectSpread(_objectSpread({}, payment), {}, {
                          transType: "GCB",
                          giftCard: _objectSpread({
                            "atg-rest-class-type": "com.darden.commerce.order.purchase.GiftCardPaymentBean"
                          }, payment.giftCard),
                          authTransID: "",
                          status: "SUCCESS"
                        }, dfpParams);
                      }

                      if (payment.payPalPayment) {
                        return _objectSpread(_objectSpread({}, payment), {}, {
                          transType: "PAYPAL_TOGO",
                          payPalPayment: _objectSpread(_objectSpread({
                            "atg-rest-class-type": "com.darden.commerce.order.purchase.PayPalPaymentBean"
                          }, payment.payPalPayment), {}, {
                            type: "PAYPAL_TOGO",
                            orderID: orderId
                          }),
                          authTransID: "",
                          status: "SUCCESS"
                        }, dfpParams);
                      }

                      if (payment.applePayPayment) {
                        var applePayPayment = payment.applePayPayment;
                        delete payment.applePayPayment;

                        if (applePayPayment.transcationInfo.paymentMethod.displayName) {
                          applePayPayment.transcationInfo.paymentMethod.displayName = encodeURIComponent(applePayPayment.transcationInfo.paymentMethod.displayName);
                        }

                        return _objectSpread(_objectSpread({}, payment), {}, {
                          transType: "APP",
                          dardenDigitalWalletBean: _objectSpread(_objectSpread({
                            "atg-rest-class-type": "com.darden.commerce.order.purchase.DardenDigitalWalletBean"
                          }, applePayPayment), {}, {
                            sdkVersion: "EC_v1"
                          }),
                          authTransID: "",
                          status: "SUCCESS"
                        }, dfpParams);
                      }

                      if (payment.googlePayPayment) {
                        var googlePayPayment = payment.googlePayPayment;
                        delete payment.googlePayPayment;
                        delete googlePayPayment.transcationInfo.info;

                        if (googlePayPayment.transcationInfo.description) {
                          googlePayPayment.transcationInfo.description = encodeURIComponent(googlePayPayment.transcationInfo.description);
                        }

                        return _objectSpread(_objectSpread({}, payment), {}, {
                          transType: "GP",
                          dardenDigitalWalletBean: _objectSpread(_objectSpread({
                            "atg-rest-class-type": "com.darden.commerce.order.purchase.DardenDigitalWalletBean"
                          }, googlePayPayment), {}, {
                            sdkVersion: "ECv1"
                          }),
                          authTransID: "",
                          status: "SUCCESS"
                        }, dfpParams);
                      }

                      return null;
                    })
                  }
                }));

              case 26:
                response = _context8.sent;
                successResp = response === null || response === void 0 ? void 0 : (_response$data14 = response.data) === null || _response$data14 === void 0 ? void 0 : _response$data14.successResponse;

                if (!successResp) {
                  _context8.next = 32;
                  break;
                }

                return _context8.abrupt("return", successResp === null || successResp === void 0 ? void 0 : successResp.order);

              case 32:
                throw {
                  errorResponse: {
                    fault: [{
                      faultCode: "SubmitOrderFail",
                      faultDescription: ""
                    }]
                  }
                };

              case 33:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function submitOrder(_x19, _x20) {
        return _submitOrder.apply(this, arguments);
      }

      return submitOrder;
    }()
  }, {
    key: "clearCart",
    value: function () {
      var _clearCart = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(orderFlow) {
        var _response$data15;

        var response, _response$data16;

        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _context9.next = 2;
                return this.axios.post(this.config.postfix.CLEAR_CART, {
                  orderFlow: orderFlow
                });

              case 2:
                response = _context9.sent;

                if (!(response !== null && response !== void 0 && (_response$data15 = response.data) !== null && _response$data15 !== void 0 && _response$data15.success)) {
                  _context9.next = 7;
                  break;
                }

                return _context9.abrupt("return", response === null || response === void 0 ? void 0 : (_response$data16 = response.data) === null || _response$data16 === void 0 ? void 0 : _response$data16.success);

              case 7:
                return _context9.abrupt("return", null);

              case 8:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));

      function clearCart(_x21) {
        return _clearCart.apply(this, arguments);
      }

      return clearCart;
    }()
  }, {
    key: "transformPaymentPayload",
    value: function transformPaymentPayload(payment, dfpParams) {
      if (payment.creditCard) {
        var _payment$creditCard$b5, _payment$creditCard$b6, _payment$creditCard$b7, _payment$creditCard$b8;

        var defaultCard = payment.creditCard["default"];
        delete payment.creditCard["default"];
        var isVaulted = payment.creditCard.isVaulted;
        delete payment.creditCard.isVaulted;
        var saveCardToProfile = payment.creditCard.saveCardToProfile;
        var saveCardParams = saveCardToProfile ? {
          updateSavedCardMandate: payment.creditCard.updateSavedCardMandate,
          acceptClientType: payment.creditCard.acceptClientType,
          acceptConceptCode: this.config.getConceptCode(),
          saveCardToProfile: true
        } : {};
        delete payment.creditCard.saveCardToProfile;
        var cardOnFileFlag = saveCardToProfile || isVaulted ? {
          cardOnFile: true
        } : {
          cardOnFile: false
        };
        return _objectSpread(_objectSpread(_objectSpread({}, payment), cardOnFileFlag), {}, {
          makePayment: isVaulted ? true : false,
          validateBillingAddress: (_payment$creditCard$b5 = payment.creditCard.billingAddress) !== null && _payment$creditCard$b5 !== void 0 && _payment$creditCard$b5.address1 && (_payment$creditCard$b6 = payment.creditCard.billingAddress) !== null && _payment$creditCard$b6 !== void 0 && _payment$creditCard$b6.postalCode && (_payment$creditCard$b7 = payment.creditCard.billingAddress) !== null && _payment$creditCard$b7 !== void 0 && _payment$creditCard$b7.firstName && (_payment$creditCard$b8 = payment.creditCard.billingAddress) !== null && _payment$creditCard$b8 !== void 0 && _payment$creditCard$b8.lastName ? true : false,
          transType: "TGC",
          "default": defaultCard,
          creditCard: _objectSpread(_objectSpread(_objectSpread(_objectSpread({
            "atg-rest-class-type": "com.darden.commerce.order.purchase.CreditCardBean"
          }, payment.creditCard), {}, {
            billingAddress: _objectSpread({
              "atg-rest-class-type": "atg.core.util.Address"
            }, payment.creditCard.billingAddress)
          }, payment.creditCard.paymentCVV ? {
            paymentCVVEnabled: true
          } : {}), dfpParams), saveCardParams),
          authTransID: "",
          status: "SUCCESS"
        });
      }

      return null;
    }
  }, {
    key: "giftCardSubmitOrder",
    value: function () {
      var _giftCardSubmitOrder = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10(orderId, gcSubmitOrderRequest) {
        var _this2 = this,
            _response$data17;

        var commonQueryParams, locale, payments, dfpParams, paymentAlreadyProcessed, response, successResp;
        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                commonQueryParams = this.config.getCommonQueryParams();
                locale = commonQueryParams && commonQueryParams.locale ? commonQueryParams.locale : "en_US";
                payments = gcSubmitOrderRequest.payments;
                delete gcSubmitOrderRequest.payments;
                dfpParams = gcSubmitOrderRequest.bamsCorrelationId ? {
                  correlationId: gcSubmitOrderRequest.bamsCorrelationId,
                  customerLocalDate: getLocalISODateString(moment().toDate())
                } : {};
                delete gcSubmitOrderRequest.bamsCorrelationId;
                paymentAlreadyProcessed = gcSubmitOrderRequest.paymentAlreadyProcessed ? "true" : "false";
                _context10.next = 9;
                return this.axios.post(this.config.postfix.GC_SUBMIT_ORDER, {
                  gcSubmitOrderRequest: gcSubmitOrderRequest,
                  paymentAlreadyProcessed: paymentAlreadyProcessed,
                  locale: locale,
                  paymentCollection: {
                    "atg-rest-class-type": "java.util.ArrayList",
                    "atg-rest-class-descriptor": {
                      "atg-rest-values": {
                        "container-class": "java.util.ArrayList",
                        "element-class": "com.darden.integration.paymentservice.bean.TransactionalDetail"
                      }
                    },
                    "atg-rest-values": payments.map(function (payment) {
                      return _this2.transformPaymentPayload(payment, dfpParams);
                    })
                  }
                });

              case 9:
                response = _context10.sent;
                successResp = response === null || response === void 0 ? void 0 : (_response$data17 = response.data) === null || _response$data17 === void 0 ? void 0 : _response$data17.successResponse;

                if (!successResp) {
                  _context10.next = 15;
                  break;
                }

                return _context10.abrupt("return", successResp === null || successResp === void 0 ? void 0 : successResp.order);

              case 15:
                throw new ErrorResponse({
                  fault: [{
                    faultCode: "SubmitOrderFail",
                    faultDescription: ""
                  }]
                });

              case 16:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, this);
      }));

      function giftCardSubmitOrder(_x22, _x23) {
        return _giftCardSubmitOrder.apply(this, arguments);
      }

      return giftCardSubmitOrder;
    }()
  }, {
    key: "setCateringDeliveryPartySize",
    value: function setCateringDeliveryPartySize(_request) {
      var commonQueryParams = this.config.getCommonQueryParams();
      var locale = commonQueryParams && commonQueryParams.locale ? commonQueryParams.locale : "en_US";
      var request = _request ? _objectSpread(_objectSpread({}, _request), {}, {
        locale: locale
      }) : {};
      return this.axios.post(this.config.postfix.SET_DELIVERY_PARTY_SIZE, request);
    }
  }, {
    key: "submitDineInOrder",
    value: function () {
      var _submitDineInOrder = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11(orderId, submitOrderRequest) {
        var _response$data18;

        var response, successResp;
        return _regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                _context11.next = 2;
                return this.axios.post(this.config.postfix.SUBMIT_ORDER, _objectSpread({}, submitOrderRequest));

              case 2:
                response = _context11.sent;
                successResp = response === null || response === void 0 ? void 0 : (_response$data18 = response.data) === null || _response$data18 === void 0 ? void 0 : _response$data18.successResponse;

                if (!successResp) {
                  _context11.next = 8;
                  break;
                }

                return _context11.abrupt("return", successResp === null || successResp === void 0 ? void 0 : successResp.order);

              case 8:
                throw {
                  errorResponse: {
                    fault: [{
                      faultCode: "SubmitOrderFail",
                      faultDescription: ""
                    }]
                  }
                };

              case 9:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, this);
      }));

      function submitDineInOrder(_x24, _x25) {
        return _submitDineInOrder.apply(this, arguments);
      }

      return submitDineInOrder;
    }()
  }, {
    key: "applyBagFee",
    value: function () {
      var _applyBagFee = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee12() {
        var _response$data19;

        var isPostCheckout,
            commonQueryParams,
            locale,
            response,
            _args12 = arguments;
        return _regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                isPostCheckout = _args12.length > 0 && _args12[0] !== undefined ? _args12[0] : true;
                commonQueryParams = this.config.getCommonQueryParams();
                locale = commonQueryParams && commonQueryParams.locale ? commonQueryParams.locale : "en_US";
                _context12.next = 5;
                return this.axios.post(this.config.postfix.APPLY_BAG_FEE, {
                  postCheckout: isPostCheckout,
                  locale: locale
                });

              case 5:
                response = _context12.sent;
                return _context12.abrupt("return", response === null || response === void 0 ? void 0 : (_response$data19 = response.data) === null || _response$data19 === void 0 ? void 0 : _response$data19.successResponse);

              case 7:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12, this);
      }));

      function applyBagFee() {
        return _applyBagFee.apply(this, arguments);
      }

      return applyBagFee;
    }()
  }, {
    key: "removeBagFee",
    value: function () {
      var _removeBagFee = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee13() {
        var _response$data20;

        var isPostCheckout,
            commonQueryParams,
            locale,
            response,
            _args13 = arguments;
        return _regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                isPostCheckout = _args13.length > 0 && _args13[0] !== undefined ? _args13[0] : true;
                commonQueryParams = this.config.getCommonQueryParams();
                locale = commonQueryParams && commonQueryParams.locale ? commonQueryParams.locale : "en_US";
                _context13.next = 5;
                return this.axios.post(this.config.postfix.REMOVE_BAG_FEE, {
                  postCheckout: isPostCheckout,
                  locale: locale
                });

              case 5:
                response = _context13.sent;
                return _context13.abrupt("return", response === null || response === void 0 ? void 0 : (_response$data20 = response.data) === null || _response$data20 === void 0 ? void 0 : _response$data20.successResponse);

              case 7:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13, this);
      }));

      function removeBagFee() {
        return _removeBagFee.apply(this, arguments);
      }

      return removeBagFee;
    }()
  }]);

  return Cart;
}();

export { Cart as default };